module.exports = __webpack_public_path__ + "img/lv1_1_1.48d33803.png";